import React, { useState, useContext, useEffect } from 'react';
import FormSketchLoader from '@components/form-sketch/FormSketchLoader';

export function FormSketchComponent({
    objectId,
    formIndex,
    repeatedIndex,
    formSketchData,
    onSave,
    onExit = () => {},
    formSketchSettings
}) {

    const { width, height, displayGrid } = formSketchSettings;

    const [showFormSketch, _setShowFormSketch] = useState(false);
    const [_formSketchData, setFormSketchData] = useState(formSketchData);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [pageScroll, setPageScroll] = useState(0);

    const onSaveInvoked = async (helper) => {
        const pageList = helper.getPages();
        const jsonPayload = helper.exportJson();
        const pageData = {};
            
        for(let i = 0; i < pageList.length; i++) {
            const page = pageList[i];

            const pngData = await helper.exportPng({
                page: page.id
            });

            pageData[page.id] = {
                pngData,
            }
        }

        setFormSketchData(
            jsonPayload
        );

        onSave({
            formData: {
                repeatedIndex,
                objectId,
                formIndex
            },
            formSketch: {
                pageData,
                canvas: jsonPayload
            }
        });
    }

    function setShowFormSketch(value) {

        _setShowFormSketch(value);

        if(value) {
            //get current scroll value.
            setPageScroll(window.scrollY);


            // document.body.style.overflow = "hidden";
            // try {
            //     document.getElementById("headerBar").style.display = "none";
            //     document.getElementById("page-wrapper").style.display = "none";
            // } catch(ex) {}
        } else {
            // document.body.style.overflow = "";
            // try {
            //     document.getElementById("page-wrapper").style.display = "";
            //     document.getElementById("headerBar").style.display = "";
            // } catch(ex) {}
            requestAnimationFrame(() => {
                window.scrollTo(0, pageScroll);
            });

        }
        setHasLoaded(true);
    }

    useEffect( () => {
        setShowFormSketch(true);
    }, []);
    
    return (
        <>
        {showFormSketch && hasLoaded && <FormSketchLoader
            width={width}
            height={height}
            displayGrid={displayGrid}
            onExitInvoked={(unsavedChanges) => new Promise( (resolve, reject) => {

                if(!confirm(unsavedChanges ? "There are unsaved changes, are you sure you wish to exit?" : "Are you sure you want to exit?")) {
                    reject();
                    return;
                }

                setShowFormSketch(false);
                onExit();
                resolve();

            })}
            formSketchData={_formSketchData}
            onSaveInvoked={onSaveInvoked}
        />}
        </>
    )
}